import { useState } from 'react';

import { useTheme } from '@mui/material';

import { useGetActiveNotificationsCount } from '@webclient/hooks/useNotificationsQuery';

import BellIcon from '~icons/knowz-iconify/bell';

import { useTranslate } from '@tolgee/react';
import { DialogsProvider } from '@toolpad/core';
import NotificationsList from '@webclient/layouts/main/sections/header/sections/notifications/notifications-list';
import {
  StyledBadge,
  StyledIconButton,
  StyledPopover,
} from '@webclient/layouts/main/sections/header/sections/notifications/styles';

export default function NotificationsPopup() {
  const theme = useTheme();
  const { t } = useTranslate();
  const notificationCount = useGetActiveNotificationsCount();
  const count =
    notificationCount > 1000
      ? `${Math.floor(notificationCount / 1000)}k`
      : notificationCount;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <DialogsProvider>
      <StyledIconButton
        onClick={handleClick}
        aria-label={t(
          'layout.main.sections.header.notifications.ariaLabel',
          'Show notifications',
        )}
      >
        <StyledBadge badgeContent={count}>
          <BellIcon color={theme.palette.text.secondary} />
        </StyledBadge>
      </StyledIconButton>

      <StyledPopover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              p: 0,
              display: 'flex',
              flexDirection: 'column',
            },
          },
        }}
      >
        <NotificationsList />
      </StyledPopover>
    </DialogsProvider>
  );
}
